import type { PlatformEnvironment } from './environment.interface';

export const environment: PlatformEnvironment = {
  production: false,

  AUTH0_DOMAIN: 'login-dev.ol-hub.com',
  AUTH0_CLIENT_ID: 'BMVvjs3MafPaj7Fcqf7zy2VcOeODUGxE',
  AUTH0_CONNECTION: 'ol-auth0-db',

  AUTH_ALLOWED_ORIGINS: [
    'https://platform.dev.ol-hub.com',
    'https://appiq.dev.openlegacy.com',
    'https://login-dev.ol-hub.com',
    'https://api.dev.ol-hub.com',
    'https://api.eu.dev.ol-hub.com',
  ],

  PLATFORM_URL: 'https://platform.dev.ol-hub.com',

  FEDERATION_MANIFEST: 'federation.manifest.dev.json',

  AUTH_SERVICE_URL: 'https://api.dev.ol-hub.com/auth-service',
  BACKOFFICE_URL: 'https://api.dev.ol-hub.com/backoffice',
  BACKEND_DOMAIN: 'https://api.dev.ol-hub.com/backend',
  RUNTIME_SERVICE_URL: 'https://api.dev.ol-hub.com/runtime',
  // Canonical OL edition flags — resolveOlEdition(environment) maps them
  // to the product edition (enterprise wins, light/olInOne → 'lite',
  // otherwise 'cloud').
  enterprise: false,
  light: false,
  olInOne: false,

  FLAGS_ROUTER_URL: 'https://api.dev.ol-hub.com/flags-router',
};
